import {Box} from 'src/design/atoms/Box';
import React from 'react';
import {SectionCard} from 'src/design/atoms/SectionCard';
import {DeviceHistoryList} from 'src/pages/Modules/Inspections/shared/DeviceHistoryList';

export interface DeviceHistorySectionProps {
  deviceId: number;
}

// InvariantId-aligned so relabeled fields still line up across form versions.
export const DeviceHistorySection: React.FC<DeviceHistorySectionProps> = ({
  deviceId,
}) => (
  <SectionCard title="Inspection History">
    <Box p="md">
      <DeviceHistoryList
        deviceId={deviceId}
        noItemsText="No inspection history recorded yet."
      />
    </Box>
  </SectionCard>
);
